module.exports = __webpack_public_path__ + "static/media/Resultat-non-disponible.17dfe24c.svg";